import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '600px',
    margin: '0 auto',
  },
}));

export default useStyles;
